<template>
  <div>
    <span :class="{'extra-question-label': isExtraQuestion}">{{ question }}</span>&nbsp;
    <b-autocomplete v-model="textEntered" :tabIndex="tab"
                    :data="filteredDataArray" :placeholder="placeholder" open-on-focus icon="earth" :disabled="isDisabled"
                    clearable @select="option => {selected = option; handleSelect();}" @input="textUpdated" dropdown-position="top"
                    :class="[{mandatory: isMandatory},'question-control']">
      <template slot="empty">
        No results found
      </template>
    </b-autocomplete>
    <span :class="[{'extra-question-label': isExtraQuestion},{'closing-tag-none':isNotDisplayed}]">{{closingTag}}</span>
  </div>
</template>

<script>

export default {
  name: 'AutocompleteQuestion',
  props: {
    question: String,
    closingTag: String,
    placeholder: String,
    isDisabled: Boolean,
    isMandatory: Boolean,
    isExtraQuestion: Boolean,
    existingValue: {
      type: String,
      default: null,
    },
    dataSource: Array,
    isNotDisplayed: Boolean,
    tab: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      textEntered: this.existingValue || '',
      selected: this.existingValue,
    };
  },
  computed: {
    filteredDataArray() {
      return this.dataSource
        .filter((item) => item.toLowerCase().indexOf(this.textEntered.toLowerCase()) >= 0);
    },
  },
  methods: {
    handleSelect() {
      this.$emit('question-answered', this.selected);
    },
    textUpdated(text) {
      if (text === '') {
        this.selected = '';
        this.handleSelect();
      }
    },
  },
  watch: {
    existingValue: {
      handler(val) {
        this.textEntered = val || '';
        this.selected = val;
      },
    },
  },
};
</script>
